<p-panel [toggleable]="true" [collapsed]="true">
  <ng-template pTemplate="header">
    <div class="color__header">
      <div class="color__box" [ngStyle]="{ 'background-color': 'gray' }"></div>
      <h4>
        {{ color?.name }}
        <small class="text-muted-color">- {{ color?.approvedRecipeNumber || ('Work_Order_Details_No_Approved_Recipe' | translateWF: 'No Approved Recipe') }}</small>
      </h4>
    </div>
  </ng-template>

  <ng-template pTemplate="icons">
    <div class="actions">
      <p-button severity="secondary" icon="pi pi-trash" (click)="removeColor()" />
    </div>
  </ng-template>

  <p-card *ngIf="garmentDetailsForm">
    <form [formGroup]="garmentDetailsForm">
      <div class="grid-auto-4 items-end">
        <div class="form-box">
          <label>Recipe/Lab Dip Number</label>
          <input
            type="text"
            pInputText
            [value]="color?.approvedRecipeNumber || ('Work_Order_Details_No_Approved_Recipe' | translateWF: 'No Approved Recipe')"
            class="w-full"
            [disabled]="!canEdit"
          />
        </div>
        <div class="form-box">
          <label>Client PO</label>
          <p-select
            formControlName="productOrderNumber"
            [options]="clientProductOrderOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select"
            class="w-full"
            [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && garmentDetailsForm.controls['productOrderNumber'].invalid }"
          />
        </div>
        <div class="form-box">
          <label>Quantity</label>
          <p-inputGroup>
            <p-inputnumber
              formControlName="quantity"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              class="w-full"
              [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && garmentDetailsForm.controls['quantity'].invalid }"
            />
            <p-inputGroupAddon> {{ uom }} </p-inputGroupAddon>
          </p-inputGroup>
        </div>
        <div class="form-box">
          <label>{{ 'Work_Order_Details_Unit_Price' | translateWF: 'Unit Price' }}</label>
          <p-inputnumber
            fluid=""
            class="w-full"
            formControlName="unitPrice"
            mode="currency"
            [minFractionDigits]="2"
            currency="USD"
            [ngClass]="{ 'ng-invalid ng-dirty': orderDetailsFormSubmitted && garmentDetailsForm.controls['unitPrice'].invalid }"
          />
        </div>
      </div>
    </form>
  </p-card>
</p-panel>
